import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, MailIcon, CheckCircleIcon } from 'lucide-react';
const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    setIsSubmitted(true);
    setIsLoading(false);
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4 sm:px-6 lg:px-8" data-id="element-1331">
      <div className="max-w-md w-full space-y-8" data-id="element-1332">
        <div data-id="element-1333">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white" data-id="element-1334">
            Reset your password
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600 dark:text-gray-400" data-id="element-1335">
            {!isSubmitted ? "Enter your email address and we'll send you a link to reset your password." : "If your email exists in our system, you'll receive a password reset link shortly."}
          </p>
        </div>
        {!isSubmitted ? <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-1336">
            <div data-id="element-1337">
              <label htmlFor="email" className="sr-only" data-id="element-1338">
                Email address
              </label>
              <div className="relative" data-id="element-1339">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1340">
                  <MailIcon className="h-5 w-5 text-gray-400" data-id="element-1341" />
                </div>
                <input id="email" name="email" type="email" autoComplete="email" required className="appearance-none rounded-md relative block w-full px-3 py-3 pl-10 border border-gray-300 dark:border-gray-600 placeholder-gray-500 dark:placeholder-gray-400 text-gray-900 dark:text-white dark:bg-gray-800 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" placeholder="Email address" value={email} onChange={e => setEmail(e.target.value)} data-id="element-1342" />
              </div>
            </div>
            <div data-id="element-1343">
              <button type="submit" disabled={isLoading} className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-70" data-id="element-1344">
                {isLoading ? 'Sending...' : 'Send reset link'}
              </button>
            </div>
          </form> : <div className="mt-8 bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800 rounded-md p-4" data-id="element-1345">
            <div className="flex" data-id="element-1346">
              <div className="flex-shrink-0" data-id="element-1347">
                <CheckCircleIcon className="h-5 w-5 text-green-400" data-id="element-1348" />
              </div>
              <div className="ml-3" data-id="element-1349">
                <h3 className="text-sm font-medium text-green-800 dark:text-green-300" data-id="element-1350">
                  Reset link sent
                </h3>
                <div className="mt-2 text-sm text-green-700 dark:text-green-400" data-id="element-1351">
                  <p data-id="element-1352">
                    If an account exists for {email}, you will receive an email
                    with instructions to reset your password.
                  </p>
                </div>
              </div>
            </div>
          </div>}
        <div className="text-center mt-4" data-id="element-1353">
          <Link to="/login" className="font-medium text-blue-600 hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300 inline-flex items-center" data-id="element-1354">
            <ArrowLeftIcon className="h-4 w-4 mr-1" data-id="element-1355" />
            Back to login
          </Link>
        </div>
      </div>
    </div>;
};
export default ForgotPassword;